import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";


const CSSLesson1 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>What is CSS?</strong></h3>
    <ul class="list-group">
        <li class="list-group-item">CSS stands for Cascading Style Sheet.</li>
        <li class="list-group-item">CSS describes how HTML elements are to be displayed on screen, paper, or in other media.</li>
        <li class="list-group-item">CSS saves a lot of work. It can control the layout of multiple web pages all at once.</li>
        <li class="list-group-item">External stylesheets are stored in CSS files.</li>
        <li class="list-group-item">CSS main objective is to provide styling and fashion to the web page.</li>
        <li class="list-group-item">CSS provides color, layout, background, font, and border properties.</li>
        <li class="list-group-item">CSS features allow better content accessibility, enhanced flexibility, and control, as well as the specification of the characteristics of presentation.</li>

        </ul>

      <div style={{ height: '45vh' }} />
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default CSSLesson1
